(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxTestSignInProfileOnPrinter(
    toastr, $filter
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        printer: '=printer',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/signInProfileProperties/testSignInProfileOnPrinter/testSignInProfileOnPrinter.template.html',
      link: function(scope) {

        scope.confirm = {
          test: false
        };

        scope.printer.verifySignInProfile().then(function(response) {
          toastr.success($filter('translate')('Ok'))
        }).catch(function(error){
          toastr.error($filter('translate')('ERROR'))
        });
        scope.callback();

      }
    };
  }

  pxTestSignInProfileOnPrinter.$inject = ['toastr', '$filter'];

  angular
    .module('printix-admin')
    .directive('pxTestSignInProfileOnPrinter', pxTestSignInProfileOnPrinter);

})();
